import { render, staticRenderFns } from "./ClasificacionProductor.vue?vue&type=template&id=02eb8a7e"
import script from "./ClasificacionProductor.vue?vue&type=script&lang=js"
export * from "./ClasificacionProductor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports